/* eslint-disable max-len */
import { RouteConfig } from 'vue-router';

const authenticateRoutes: Array<RouteConfig> = [];

export default authenticateRoutes;
